/*
 * @Description:
 * @Author: keke
 * @Date: 2022-07-25 23:05:15
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-01 17:32:28
 * @FilePath: \ossoo\src\utils\index.js
 */
// import Vue from 'vue';
import axios from 'axios'
import { checkLogin as checkLoginApi, loginByParams as loginByParamsApi ,loginUgcLoginToBook as loginUgcLoginToBookApi } from '../apis/init'
import { useBaseStore } from "@/stores/base";
import dataCenterV2Apis from '../apis/dataCenterV2'
import localforage from 'localforage'
import dayjs from 'dayjs'
import { Message } from 'element-ui';
const dataCenterBase = localforage.createInstance({
  name: 'dataCenterBase'
})
import { useUserStore } from '@/stores/user'
import { useInstStore } from '@/stores/inst'

// 差集 a去掉b中的元素 没有则不做处理
export function minus(a, b) {
  let sb = new Set(b);
  return a.filter(x => !sb.has(x))
}

// 并集 总共的元素
export function unionSet(a, b) {
  return Array.from(new Set([...a, ...b]));
}

// 返回字节长度
export const getBytes = (str) => {
  return str.replace(/[^\x00-\xff]/g, 'xx').length
}

// 检查版本
export const checkVersion = async () => {
  const url = `/static/js/version.json?t=${Date.now()}`
  let res = null
  try {
    res = await axios.get(url)
  } catch (err) {
    console.log('检查版本失败', err)
  }
  let version = null
  if (res) {
    version = res.data.version
  }
  console.log('当前版本打包', version)
  const localVersion = localStorage.getItem('localVersion')
  console.log('本地运行版本', localVersion)
  if (version && localVersion != version) {
    localStorage.setItem('localVersion', version)
    window.location.reload()
  }
  localStorage.setItem('localVersion', version)
}

// 免登录逻辑
export const checkLogin = async () => {
  return new Promise(resolve => {
    const params = {
      token: localStorage.getItem('token')
    }
    checkLoginApi(params).then(res => {
      if (res.code == 0) {
        if (Array.isArray(res.data) || !res.data.hasOwnProperty('baseUrl')) {
          resolve(401.1)
        } else {
          const baseStore = useBaseStore();
          baseStore.init(res.data)
          resolve(200)
        }
      }
    })
  })

}

// 通过token, serverId, domain登陆
export const loginByParams = async (data) => {
  return new Promise(resolve => {
    loginByParamsApi(data).then(res => {
      if (res.code == 0) {
        const baseStore = useBaseStore();
        baseStore.init(res.sessionData)
        resolve(200)
      } else {
        resolve(401.1)
      }
    })
  })

}
// 老ugc跳转新后台登陆验证
export const ugcLoginToBook = async (username,serverId,bookOrder,userId) => {
  
  return new Promise(async resolve => {
    let paramsData = {
      bookOrder: bookOrder || false,//图书订单
      serverId: serverId || false,//服务器ID
      userName: username ,//登陆的用户名
      userId:userId,//用户ID
    }
    const res = await loginUgcLoginToBookApi(paramsData)
    if (res.code == 0) {
      let sessionData = res.sessionData
      const baseStore = useBaseStore()
      baseStore.init(sessionData)
      resolve()
    } else {
      Message.error(res.message)
      resolve()
    }
  })
}

// 图片url替换
export function changeImgUrl(url) {
  return url.replace('lstyty.oss-cn-hangzhou.aliyuncs.com', 'cdnws.51tyty.com')
    .replace('res.iiiview.net', 'cdnws.51tyty.com')

}

// 图片url替换-缩略图
export function thumbnailUrl(url, m='640', h='480') {
  url = url.replace('lstyty.oss-cn-hangzhou.aliyuncs.com', 'cdnws.51tyty.com')
    .replace('res.iiiview.net', 'cdnws.51tyty.com');
  // 使用split分割字符串，并取最后一部分
  const extension = url.split('.').pop();
  // 检查是否是一个已知的图片文件格式
  const knownExtensions = ['jpg', 'jpeg', 'png', 'gif'];
  let type = ''
  if (knownExtensions.includes(extension)) {
    type = extension; // 返回后缀名
  } else {
    type = 'jpg'; // 不是常见的图片后缀或者没有后缀名
  }
  if(url.indexOf('?x-oss-process=image/resize') > -1 || url.indexOf('?spm=qipa250&x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast') > -1) {
    return url
  } else {
    return `${url}?x-oss-process=image/resize,m_lfit,w_${m},h_${h}/format,${type}`
  }
}

// 导出逻辑
export function exportFunc(name, res) {
  const blob = new Blob([res], {
    type: "application/vnd.ms-excel",
  });
  const fileName = name;
  const linkNode = document.createElement("a");
  linkNode.download = fileName; //a标签的download属性规定下载文件的名称
  linkNode.style.display = "none";
  linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
  document.body.appendChild(linkNode);
  linkNode.click(); //模拟在按钮上的一次鼠标单击
  URL.revokeObjectURL(linkNode.href); // 释放URL对象
  document.body.removeChild(linkNode);
}

// 跳转支付页面
export function postBillPage(url, params) {
  var windowname = "_blank";
  var form = document.createElement("form");
  form.method = "post";
  form.action = url;
  var input;
  const keys = Object.keys(params);
  keys.forEach((key) => {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = params[key];
    form.appendChild(input);
  });
  form.target = windowname;
  console.log(form);
  document.body.appendChild(form);
  window.dispatchEvent(new Event("onsubmit"));
  form.submit();
}

// 获取quick bi版本数据中心的嵌入url
export const getQuickBIUrl = (key, instId) => {
  return new Promise((resolve, reject) => {
    const userStore = useUserStore()
    const instStore = useInstStore()
    const params = {
      instId,
      key,
      subject: instStore.subject,
      teacherId:userStore.userId,
      role: userStore.role
    }
    dataCenterV2Apis.getQuickBIUrl(params).then(async(res) => {
      if (res.code == 0) {
        let bdData = await dataCenterBase.getItem(instId)
        if (!bdData) {
          bdData = {}
        }
        bdData[key] = res.data[0]
        await dataCenterBase.setItem(instId, bdData)
        resolve()
      } else {
        reject()
      }
    })
  })
}

// 获取quick bi相关数据
// 如果没有则调用生成接口,有则调用check接口
export const getQuickBiData = (to) => {
  return new Promise(async(resolve) => {
    const baseStore = JSON.parse(sessionStorage.getItem('baseStore'))
    let key = ''
    switch (to.path) {
      case '/dataCenterV2/overviewData':
        key = 'dataOverview'
        break;
      case '/dataCenterV2/salerData':
        key = 'salesData'
        break;
      case '/dataCenterV2/educationalData':
        key = 'educationData'
        break;
      case '/dataCenterV2/teachingData':
        key = 'teachingData'
        break;
      case '/dataCenterV2/financeData':
        key = 'financialData'
        break;
      case '/dataCenterV2/studyDataOld':
        key = 'learningData'
        break;
      case '/dataCenterV2/studyData':
        key = 'learningData'
        break;
      case '/dataCenterV2/reportData':
        key = 'reportData'
        break;
      case '/begin/dataCenterV2':
        if (baseStore.accessType == 'school') {
          key = 'sDataCenter'
        } else {
          key = 'cDataCenter'
        }
        break;
    }

    let instId = ''
    if (['sDataCenter', 'cDataCenter'].includes(key)) {
      if (baseStore.accessType == 'school') {
        // 学校数据需要用主校区instId
        baseStore.myProfile.schoolsAndCourses.map(item => {
          if (item.isMainSchool == 'true') {
            instId = item.instId
          }
        })
      } else {
        // 校区维度需要用当前校区instId
        if (to.query.campusId) {
          instId = to.query.campusId
        } else {
          instId = baseStore.instInfo.id
          baseStore.myProfile.schoolsAndCourses.map(item => {
            if (item.instId == instId) {
              instId = item.instId
            } else {
              const result = item.courses.find(f => f.instId == instId)
              if (result) {
                instId = item.instId
              }
            }
          })
        }
      }
    } else {
      instId = baseStore.instInfo.id
    }

    const result = await dataCenterBase.getItem(instId)

    if (!result || !result[key]) {
      // 如果没有数据调用生成接口
      await getQuickBIUrl(key, instId)
    } else {
      // 如果有数据先检测有没有过期
      const iframeData = result[key]
      console.log('iframeData', iframeData)
      const invalidTime = iframeData.ticketInfo.invalidTime // 过期时间
      const endTime = dayjs(invalidTime).format('YYYY-MM-DD HH:mm:ss')
      const nowTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      console.log(nowTime >= endTime)
      if (nowTime >= endTime) {
        await getQuickBIUrl(key, instId)
      }
    }
    resolve()
  })

}

// 是否为内部机构
export function isInnerInst(instId) {
  //  机构Id:lingshi-216、zhihui-5、dubbing-23、exam-24、abc123-101、付费书籍shuji-1639、课程制作course-1926
  let list = [216,5,23,24,101,1639,1926];
  return list.includes(instId)
}

export default {
  getBytes,
  checkVersion,
  checkLogin,
  loginByParams,
  exportFunc,
  postBillPage,
  getQuickBiData,
  isInnerInst,
}
